// extracted by mini-css-extract-plugin
module.exports = {"badge":"r2","isRental":"r3","badgeWrapper":"r4","hide":"r5","roundedBadge":"r6","gridBadge":"r7"};